import { render, staticRenderFns } from "./Waves.vue?vue&type=template&id=29fd67fe&scoped=true"
import script from "./Waves.vue?vue&type=script&lang=js"
export * from "./Waves.vue?vue&type=script&lang=js"
import style0 from "./Waves.vue?vue&type=style&index=0&id=29fd67fe&prod&lang=scss&scoped=true"
import style1 from "./Waves.vue?vue&type=style&index=1&id=29fd67fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fd67fe",
  null
  
)

export default component.exports